import $$ from 'cmn-utils'

const baseUrl = "/api/sys/unit/v2/share/";
export default {
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
}